export const fr = {
  // Common
  common: {
    loading: "Chargement...",
    error: "Une erreur est survenue",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    search: "Rechercher",
    filter: "Filtrer",
    all: "Tout",
    none: "Aucun",
    yes: "Oui",
    no: "Non",
    or: "ou",
  },

  // Auth
  auth: {
    login: "Connexion",
    register: "Inscription",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    fullName: "Nom complet",
    forgotPassword: "Mot de passe oublié ?",
    noAccount: "Pas encore de compte ?",
    hasAccount: "Déjà un compte ?",
    continueWithGoogle: "Continuer avec Google",
    loginSuccess: "Connexion réussie",
    registerSuccess: "Inscription réussie",
    logoutSuccess: "Déconnexion réussie",
    invalidCredentials: "Email ou mot de passe incorrect",
    emailRequired: "L'email est requis",
    passwordRequired: "Le mot de passe est requis",
    passwordTooShort: "Mot de passe : 10 caractères minimum, avec 2 parmi chiffre, symbole, majuscule",
    emailAlreadyExists: "Cet email est déjà utilisé",
  },

  // Navigation
  nav: {
    home: "Accueil",
    dashboard: "Tableau de bord",
    interviews: "Entretiens",
    resumes: "CV",
    profile: "Profil",
    settings: "Paramètres",
    admin: "Administration",
    groups: "Groupes",
  },

  // Landing Page
  landing: {
    hero: {
      badge: "Plateforme carrière tout-en-un",
      title: "Toute ta recherche d'emploi dans un seul écosystème",
      subtitle:
        "Un seul endroit pour ton CV, tes lettres, tes entretiens, ton LinkedIn et le suivi de tes candidatures. Chaque outil s'appuie sur les autres — un seul effort, résultat partout.",
      cta: "Créer mon compte gratuit",
      secondaryCta: "Voir la démo",
      reassurance: "Gratuit · Sans carte bancaire · En français",
      login: "Se connecter",
    },
    trustBar: {
      item1: "Pensée pour le marché français",
      item2: "Tes données restent privées",
      item3: "Propulsé par les meilleures IA du marché",
    },
    problem: {
      title: "Trouver un job, ça ne devrait pas être un deuxième job.",
      subtitle: "On connaît la galère. Velyq la simplifie.",
      without: {
        title: "Sans Velyq",
        items: [
          "Des heures à refaire ton CV pour chaque offre",
          "Des outils éparpillés : ChatGPT, Canva, LinkedIn…",
          "Des entretiens ratés par manque de préparation",
          "Aucune idée de ton score de compatibilité ATS",
        ],
      },
      with: {
        title: "Avec Velyq",
        items: [
          "CV optimisé en 30 secondes pour chaque offre",
          "Tous tes outils carrière au même endroit",
          "Simulations d'entretien vocales avec feedback IA",
          "Score ATS précis + suggestions concrètes",
        ],
      },
    },
    solutions: {
      title: "Tout ce qu'il faut pour décrocher le poste",
      subtitle: "Une plateforme, tous les outils. Chaque solution travaille ensemble pour maximiser tes chances.",
      interview: {
        title: "Préparation Entretien",
        description: "Questions personnalisées basées sur ton CV et l'offre. Général, tech, consulting, finance.",
        cta: "S'entraîner",
      },
      ats: {
        title: "Analyse CV (ATS)",
        description: "Score de compatibilité, mots-clés manquants, suggestions avant/après par secteur.",
        cta: "Analyser mon CV",
      },
      coverLetter: {
        title: "Lettre de Motivation IA",
        description: "Génère une lettre personnalisée en 30 secondes à partir de ton CV et de l'offre.",
        cta: "Générer une lettre",
        badge: "Nouveau",
      },
      resume: {
        title: "CV Builder",
        description: "Crée un CV optimisé ATS avec des templates pros et des suggestions IA.",
        cta: "Créer mon CV",
      },
      linkedin: {
        title: "LinkedIn IA",
        description: "Analyse et optimise ton profil LinkedIn : headline, résumé, expériences.",
        cta: "Optimiser",
        badge: "Nouveau",
      },
    },
    howItWorks: {
      title: "3 étapes pour décrocher ton job",
      subtitle: "De l'upload du CV à la signature du contrat.",
      step1: {
        title: "Importe ton CV",
        description: "Ajoute ton CV en PDF. Velyq extrait tes expériences automatiquement.",
      },
      step2: {
        title: "Choisis un outil",
        description: "Entretien, analyse ATS, lettre, LinkedIn — tes données se synchronisent partout.",
      },
      step3: {
        title: "Décroche le job",
        description: "L'IA travaille pour toi. Tu te concentres sur ce qui compte : postuler.",
      },
    },
    whyVelyq: {
      title: "Pourquoi Velyq ?",
      subtitle: "Ce que les autres plateformes ne font pas.",
      reason1: {
        title: "Pensé FR",
        description: "Modes tech, consulting, finance adaptés aux entreprises françaises et à la culture du travail en France.",
      },
      reason2: {
        title: "Écosystème connecté",
        description: "Ton CV nourrit tes entretiens. Ta lettre réutilise tes compétences. Tout est lié — aucun copier-coller.",
      },
      reason3: {
        title: "Voix IA accessible",
        description: "Entretiens vocaux en temps réel à 25€/mois. Les concurrents facturent 148€+ pour la même techno.",
      },
      reason4: {
        title: "Freemium généreux",
        description: "Tous les outils en version gratuite. Pas de carte bancaire. Upgrade quand tu veux.",
      },
    },
    features: {
      title: "Conçu pour décrocher le poste",
      interview: {
        title: "Questions personnalisées",
        description:
          "L'IA génère des questions adaptées à ton CV et au poste que tu vises. Comportemental, technique ou motivation.",
      },
      feedback: {
        title: "Feedback détaillé",
        description:
          "Après chaque réponse, reçois une évaluation avec des conseils concrets pour t'améliorer.",
      },
      cv: {
        title: "Analyse de ton CV",
        description:
          "Upload ton CV (PDF) et Velyq extrait automatiquement tes expériences pour personnaliser les questions.",
      },
      progress: {
        title: "Suivi de progression",
        description: "Visualise tes scores au fil du temps et identifie tes points à travailler.",
      },
      star: {
        title: "Méthode STAR",
        description:
          "Apprends à structurer tes réponses avec la méthode Situation-Tâche-Action-Résultat.",
      },
      pitch: {
        title: "Entraînement Pitch",
        description:
          "Perfectionne ta présentation \"Parlez-moi de vous\" avec un feedback personnalisé.",
      },
    },
    faq: {
      title: "Questions fréquentes",
      q1: {
        question: "C'est vraiment gratuit ?",
        answer: "Oui, Velyq offre un plan gratuit avec accès à tous les outils : entretiens, analyse ATS, lettres de motivation et plus. Le plan Pro débloque l'usage illimité.",
      },
      q2: {
        question: "Comment fonctionne l'IA ?",
        answer: "Velyq s'appuie sur plusieurs modèles d'IA de pointe pour générer des questions pertinentes, analyser ton CV et créer du contenu personnalisé. Le modèle le plus adapté est sélectionné selon la tâche.",
      },
      q3: {
        question: "Mes données sont-elles sécurisées ?",
        answer: "Oui. Ton CV et tes données sont stockés de manière sécurisée. Nous ne partageons jamais tes données avec des tiers.",
      },
      q4: {
        question: "Je peux utiliser Velyq en anglais ?",
        answer: "Oui ! Tous les outils fonctionnent en français et en anglais. Tu peux changer la langue à tout moment.",
      },
      q5: {
        question: "Qu'est-ce qui est inclus dans Premium ?",
        answer: "Premium débloque l'usage illimité de tous les outils : entretiens (classiques et Live vocaux), analyses ATS, lettres de motivation, LinkedIn rewrite, CV Builder et les modes sectoriels (tech, consulting, finance).",
      },
    },
    cta: {
      title: "Prêt à décrocher ton prochain job ?",
      subtitle: "Crée ton compte en 30 secondes. Accède à tous les outils gratuitement, sans carte bancaire.",
      button: "Commencer gratuitement",
      reassurance: "Gratuit · Sans carte bancaire · Moins de 30 secondes",
    },
    pricing: {
      title: "Tarifs",
      free: {
        name: "Gratuit",
        price: "0€",
        description: "Tous les outils inclus",
        features: [
          "3 entretiens / mois",
          "1 analyse ATS / mois",
          "1 lettre de motivation / mois",
          "Analyse LinkedIn",
          "Sans carte bancaire",
        ],
      },
      premium: {
        name: "Premium",
        price: "9,99€/mois",
        description: "Usage illimité, tout inclus",
        features: [
          "Entretiens illimités (classiques + Live vocaux)",
          "Analyses ATS illimitées",
          "Lettres de motivation illimitées",
          "LinkedIn : rewrite IA",
          "CV Builder complet · Export PDF",
          "Modes tech, consulting, finance",
        ],
      },
    },
  },

  // Dashboard
  dashboard: {
    welcome: "Bienvenue",
    welcomeBack: "Content de te revoir",
    stats: {
      interviews: "Entretiens",
      avgScore: "Score moyen",
      progress: "Progression",
      streak: "Série",
    },
    quickActions: {
      title: "Actions rapides",
      newInterview: "Nouvel entretien",
      uploadCV: "Uploader un CV",
      viewHistory: "Voir l'historique",
    },
    recentActivity: {
      title: "Activité récente",
      noActivity: "Aucune activité récente",
    },
  },

  // Profile
  profile: {
    title: "Mon profil",
    subtitle: "Gérer tes informations personnelles",
    tabs: {
      personal: "Informations personnelles",
      academic: "Parcours académique",
      career: "Objectifs de carrière",
      preferences: "Préférences",
    },
    personal: {
      fullName: "Nom complet",
      email: "Email",
      avatar: "Photo de profil",
      changeAvatar: "Changer la photo",
    },
    academic: {
      school: "École / Université",
      fieldOfStudy: "Domaine d'étude",
      graduationYear: "Année de diplôme",
      experienceLevel: "Niveau d'expérience",
      levels: {
        student: "Étudiant",
        junior: "Junior (0-2 ans)",
        mid: "Confirmé (2-5 ans)",
        senior: "Senior (5+ ans)",
      },
    },
    career: {
      targetRoles: "Postes visés",
      targetRolesPlaceholder: "Ex: Développeur, Data Analyst, Chef de projet",
      targetSectors: "Secteurs visés",
      targetSectorsPlaceholder: "Ex: Tech, Finance, Conseil",
    },
    preferences: {
      uiLanguage: "Langue d'affichage",
      interviewLanguage: "Langue des entretiens",
      languages: {
        fr: "Français",
        en: "English",
      },
    },
    saveSuccess: "Profil mis à jour avec succès",
    saveError: "Erreur lors de la mise à jour du profil",
  },

  // Groups
  groups: {
    title: "Groupes",
    myGroups: "Mes groupes",
    createGroup: "Créer un groupe",
    joinGroup: "Rejoindre un groupe",
    members: "membres",
    types: {
      school: "École",
      company: "Entreprise",
      other: "Autre",
    },
    roles: {
      owner: "Propriétaire",
      admin: "Administrateur",
      member: "Membre",
    },
  },

  // Interviews
  interviews: {
    title: "Entretiens",
    new: "Nouvel entretien",
    history: "Historique",
    types: {
      behavioral: "Comportemental",
      technical: "Technique",
      motivation: "Motivation",
      mixed: "Mixte",
    },
    difficulty: {
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé",
    },
    status: {
      created: "Créé",
      in_progress: "En cours",
      completed: "Terminé",
      abandoned: "Abandonné",
    },
  },

  // ATS Analysis
  ats: {
    title: "Analyse ATS",
    subtitle: "Vérifiez la compatibilité de votre CV avec une offre d'emploi",
    analyzing: "Analyse en cours...",
    analyzingDescription: "Notre IA compare votre CV avec les critères de l'offre",
    analyzeCompatibility: "Analyser la compatibilité",
    score: "Score ATS",
    summary: "Résumé",
    // Results page
    results: {
      title: "Résultats de l'analyse ATS",
      backToResume: "Retour au CV",
      reanalyze: "Relancer l'analyse",
      exportPdf: "Exporter en PDF",
      editResume: "Modifier le CV",
    },
    // Section scores
    sections: {
      title: "Scores par section",
      experience: "Expérience",
      skills: "Compétences",
      education: "Formation",
      format: "Format",
    },
    // Keywords
    keywords: {
      matched: "Mots-clés trouvés",
      missing: "Mots-clés manquants",
      foundIn: "Trouvé dans",
      addTo: "Ajouter dans",
    },
    // Tips & Suggestions
    tips: {
      title: "Conseils d'amélioration",
      priority: {
        high: "Priorité haute",
        medium: "Priorité moyenne",
        low: "Priorité basse",
      },
      categories: {
        skills: "Compétences",
        experience: "Expérience",
        education: "Formation",
        format: "Format",
        summary: "Résumé",
        general: "Général",
      },
      before: "Avant",
      after: "Après",
    },
    // Strengths & Issues
    strengths: "Points forts",
    formatIssues: "Problèmes de format",
    // Job offer
    jobOffer: {
      title: "Offre d'emploi",
      existingOffer: "Offre existante",
      newOffer: "Nouvelle offre",
      noSavedOffers: "Aucune offre enregistrée",
      pasteText: "Coller le texte",
      manualInput: "Saisie manuelle",
      urlInput: "URL",
      comingSoon: "Bientôt disponible",
      parseWithAI: "Analyser avec l'IA",
      parsing: "Analyse en cours...",
      parsed: "Offre analysée",
      startOver: "Recommencer",
      useThisOffer: "Utiliser cette offre",
      jobTitle: "Titre du poste",
      company: "Entreprise",
      location: "Localisation",
      contractType: "Type de contrat",
      description: "Description du poste",
      requirements: "Prérequis / Exigences",
      keySkills: "Compétences clés",
      addSkill: "Ajouter une compétence",
      requiredSkills: "Compétences requises",
      niceToHave: "Compétences bonus",
      experienceLevel: "Expérience",
    },
    // Premium
    premium: {
      unlockTitle: "Débloquer avec Premium",
      unlockDescription: "Accédez à l'analyse complète",
      hiddenItems: "éléments masqués",
      limitReached: "Limite atteinte",
      freeRemaining: "analyse gratuite restante",
      unlimitedAnalyses: "Premium = analyses illimitées + résultats complets",
      goPremium: "Passer Premium pour analyser",
    },
    // CV Viewer
    cvViewer: {
      viewMode: "Vue",
      editMode: "Édition",
      showHighlights: "Afficher les highlights ATS",
      hideHighlights: "Masquer les highlights ATS",
    },
    // Job types
    jobTypes: {
      cdi: "CDI",
      cdd: "CDD",
      stage: "Stage",
      alternance: "Alternance",
      freelance: "Freelance",
      other: "Autre",
    },
  },

  // Footer
  footer: {
    rights: "Tous droits réservés",
    privacy: "Confidentialité",
    terms: "Conditions d'utilisation",
    contact: "Contact",
  },

  // Blog
  blog: {
    pageTitle: "Blog Velyq — Conseils carrière, entretien et CV",
    heroTitle: "Blog",
    heroSubtitle:
      "Conseils, stratégies et techniques pour réussir vos entretiens et trouver le bon poste.",
    featuredSection: "Articles à la une",
    allSection: "Tous les articles",
    empty: "Les premiers articles arrivent bientôt…",
    noResults: "Aucun article ne correspond à ta recherche.",
    resetFilters: "Réinitialiser",
    searchPlaceholder: "Rechercher un article…",
    allCategories: "Toutes les catégories",
    readArrow: "Lire",
    readTimeSuffix: "min",
    ctaTitle: "Prêt à mettre en pratique ces conseils ?",
    ctaSubtitle: "Entraîne-toi avec notre simulateur d'entretien IA.",
    ctaButton: "Commencer gratuitement",
    article: {
      backToBlog: "Retour au blog",
      readTime: "min de lecture",
      relatedTitle: "Articles similaires",
      tocLabel: "Sur cette page",
      ctaTitle: "Prêt à mettre ces conseils en pratique ?",
      ctaSubtitle:
        "Entraîne-toi avec notre simulateur d'entretien IA et reçois un feedback personnalisé.",
      ctaButton: "Commencer gratuitement",
    },
  },

  // Training Hub (cold call simulator)
  training: {
    nav: "Entraînement",
    title: "Entraînement",
    subtitle: "Simulateurs vocaux IA pour les commerciaux français",
    quota: {
      usedFree: "Free · {used}/{limit} ce mois",
      unlimited: "Premium · illimité",
      limitReached: "Limite atteinte",
      tooltipFree:
        "3 sessions gratuites par mois. Passe en Premium pour des cold calls illimités.",
      tooltipPremium: "Plan Premium — sessions illimitées.",
    },
    categories: {
      cold_call: "Cold Call SDR",
    },
    difficulty: {
      easy: "Facile",
      medium: "Moyen",
      hard: "Difficile",
    },
    status: {
      created: "Créée",
      in_progress: "En cours",
      completed: "Terminée",
      abandoned: "Abandonnée",
      scored: "Notée",
    },
    hub: {
      lastSessions: "Tes dernières sessions",
      seeAll: "Tout voir",
      noSessionsYet:
        "Aucune session pour l'instant — choisis un persona ci-dessus pour commencer.",
      personasEmpty:
        "Aucune persona disponible. Vérifie que le backend est bien initialisé.",
    },
    persona: {
      backToHub: "Retour à l'entraînement",
      traitsTitle: "Traits",
      contextTitle: "Contexte",
      objectionsTitle: "Objections probables",
      scenariosTitle: "Scénarios disponibles",
      scenariosCount: "{n} scénario(s) disponible(s)",
      durationMinutes: "{n} min",
      notFound: "Persona introuvable",
    },
    scenario: {
      backToPersona: "Retour à la persona",
      personaTitle: "Persona",
      contextTitle: "Contexte de l'appel",
      objectionsTitle: "Objections attendues",
      scoringTitle: "Tu seras scoré sur",
      startCta: "Démarrer l'appel · {minutes} min",
      starting: "Création de la session…",
      notFound: "Scénario introuvable",
      durationMinutes: "{n} min",
      customPitchTitle: "Pitche ton produit (optionnel)",
      customPitchPlaceholder: "Décris ton produit en 1-3 phrases pour des objections plus réalistes…",
      customPitchPlaceholderFreeLocked: "Pitche ton vrai produit en Premium",
      customPitchSavedHint: "Pré-rempli depuis tes paramètres. Modifie pour cette session uniquement.",
    },
    live: {
      preparing: "Préparation de l'appel…",
      micNotice:
        "Ton micro va être activé. Parle naturellement — l'IA écoute et te répond en temps réel.",
      startCallCta: "Démarrer l'appel",
      hangupCta: "Raccrocher",
      mute: "Couper le micro",
      unmute: "Réactiver le micro",
      ending: "Sauvegarde…",
      transcriptTitle: "Transcription en direct",
      transcriptEmpty: "L'échange va apparaître ici dès que vous parlez…",
      messages: "messages",
      you: "Toi",
      agent: "IA",
      errorTitle: "Connexion impossible",
      errorBody: "On n'a pas pu joindre l'agent IA. Réessaie dans un instant.",
      toastConnectionError: "Connexion à l'agent IA interrompue",
      toastStartError: "Impossible de démarrer l'appel — vérifie ton micro.",
      toastEndError: "La session a fini mais on n'a pas pu sauvegarder. On réessaiera.",
    },
    results: {
      notFound: "Session introuvable",
      backToSessions: "Retour à mes sessions",
      backToCatalog: "Retour au catalogue",
      viewAllSessions: "Voir mes sessions",

      // Loading + states
      scoringInProgress: "Analyse en cours…",
      scoringHint:
        "Le coach analyse ton call selon les frameworks Sandler / Challenger / SPIN / LAER. Cela prend 5 à 15 secondes.",
      scoringFailedTitle: "Analyse échouée",
      scoringFailedBody:
        "On n'a pas pu finaliser l'analyse. Réessaie dans quelques secondes.",
      retryAnalysis: "Réessayer l'analyse",

      // Verdicts (above tabs)
      verdictProduction: "Appel qualité production",
      verdictBookable: "Meeting bookable — quelques axes à corriger",
      verdictReplay: "À rejouer — fondations à consolider",
      verdictShortCall: "Call trop court pour un scoring fiable",

      // Tabs
      tabView: "Vue",
      tabTranscript: "Transcript",
      tabCoaching: "Coaching",

      // Vue tab
      breakdownTitle: "Breakdown",
      top3Title: "3 priorités prochaine session",
      voiceMetricsTitle: "Voice metrics",
      voiceTalkRatio: "Temps de parole",
      voicePace: "Débit",
      voiceFillers: "Fillers",
      estimatedBadge: "estimé",

      // Criteria labels (used in Vue + Coaching tabs)
      criterion_opener: "Opener & Permission",
      criterion_pertinence: "Pertinence & Personnalisation",
      criterion_discovery: "Discovery & Écoute",
      criterion_objection: "Traitement d'objection",
      criterion_closing: "Closing & CTA",

      // Coaching cards
      citationLabel: "Citation",
      adviceLabel: "Conseil",
      exampleLabel: "Exemple",
      viewInTranscript: "Voir dans transcript",

      // Transcript labels
      you: "Toi",
      agent: "IA",
    },
    sessions: {
      title: "Mes sessions d'entraînement",
      subtitle: "Toutes tes sessions de cold call, du plus récent au plus ancien.",
      emptyState:
        "Aucune session pour l'instant. Lance ton premier cold call depuis le catalogue.",
      goToCatalog: "Aller au catalogue",
      colDate: "Date",
      colScenario: "Scénario",
      colStatus: "Statut",
      colDuration: "Durée",
      colScore: "Score",
      durationDash: "—",
      scoreDash: "—",
      previous: "Précédent",
      next: "Suivant",
    },
    upgrade: {
      banner: "Tu as atteint la limite Free de 3 sessions ce mois.",
      bannerCta: "Passer en Premium",
      toastQuotaReached:
        "Tu as utilisé tes 3 sessions gratuites du mois. Passe en Premium pour continuer.",
      toastError: "Impossible de créer la session. Réessaie dans un instant.",
    },
    paywall: {
      quotaTitle: "Tu as utilisé tes 3 sessions gratuites du mois.",
      quotaBody: "Continue à t'entraîner sans limite avec Premium. Illimité, custom pitch, replay audio, export PDF — 9,99 €/mois.",
      quotaPrimary: "Passer en Premium",
      quotaSecondary: "Plus tard",
      personaHardTitle: "{name} est un persona Premium.",
      personaHardBody: "Les personas Hard (DSI agacé, CFO formel) sont les plus exigeants — réservés aux Premium.",
      personaHardPrimary: "Débloquer Premium",
      personaHardSecondary: "Voir les personas Free",
      customPitchTitle: "Pitche ton vrai produit en Premium.",
      customPitchBody: "Colle ton pitch maison, le prospect IA s'adapte à ton produit réel — pas un produit fictif.",
      customPitchPrimary: "Passer en Premium",
      customPitchSecondary: "Plus tard",
    },
  },

  // Settings
  settings: {
    customPitch: {
      title: "Mon produit",
      subtitle: "Décris ton produit pour des sessions training plus réalistes.",
      placeholder: "Ex : on vend un SaaS de gestion des notes de frais aux PME 50-500 personnes…",
      saveCta: "Enregistrer",
      saving: "Enregistrement…",
      saved: "Enregistré.",
      saveError: "Impossible d'enregistrer. Réessaye.",
      lockedHint: "Disponible avec Premium.",
      lockedCta: "Débloquer Premium",
      maxLengthHint: "{count}/2000 caractères",
    },
  },
} as const;

export type TranslationKeys = typeof fr;
